const imgurl = {
  logo: require("./alopexia.png"),
  stack: require("./stack.png"),
  capture: require("./capture.png"),
  upload: require("./upload.png"),
  loginbg: require("./loginpgimgs/Background.png"),
  logo1: require("./loginpgimgs/logo.png"),
  flag: require("./loginpgimgs/flag.png"),
  flag1: require("./loginpgimgs/India_flag.png"),
  arrows: require("./loginpgimgs/arrows.png"),
  shape: require("./loginpgimgs/shape.png"),
  otpbg: require("./otppgimgs/Background.png"),
  profilebg: require("./profilepgimg/Background.png"),
  backarrow: require("./otppgimgs/backarrow.png"),
  shape2: require("./otppgimgs/shape2.png"),
  thinhair: require("./asessmentpgimgs/thinhair.png"),
  shorthair: require("./asessmentpgimgs/shorthair.png"),
  mediumhair: require("./asessmentpgimgs/mediumhair.png"),
  longhair: require("./asessmentpgimgs/longhair.png"),
  questionnairebg1: require("./questionnaireimgs/Background.png"),
  questionnairebg2: require("./questionnaireimgs/Background2.png"),
  hairpattern1: require("./questionnaireimgs/hairpattern1.png"),
  hairpattern2: require("./questionnaireimgs/hairpattern2.png"),
  hairpattern3: require("./questionnaireimgs/hairpattern3.png"),
  hairpattern4: require("./questionnaireimgs/hairpattern4.png"),
  hairpattern5: require("./questionnaireimgs/hairpattern5.png"),
  imguploadbg: require("./imgupload/Background.png"),
  prescriptionbg: require("./prescuploadimg/Background.png"),
  prescupload: require("./prescuploadimg/presupload.png"),
  product: require("./productdetlsimg/tablet.png"),
  shapeblue: require("./shapeblue.png"),
  bot: require("./bot.png"),
  onboardingbg1: require("./onboardingimgs/slide1.png"),
  onboardingbg2: require("./onboardingimgs/slide2.png"),
  frontview: require("./imgupload/frontview.png"),
  backview: require("./imgupload/backview.png"),
  topview: require("./imgupload/topview.png"),
  sideview: require("./imgupload/sideview.png"),
  sideview1: require("./imgupload/sideview1.png"),
  getresultbg: require("./getresultimg/Bg.png"),
  profile: require("./resultpgimgs/profileimg.png"),
  sidebarprofile: require("./sidebarimgs/sidebar_profile.png"),
  star: require("./sidebarimgs/star.png"),
  feedback: require("./sidebarimgs/feedback.png"),
  globe: require("./sidebarimgs/Globe.png"),
  cart: require("./sidebarimgs/cart.png"),
  summary: require("./sidebarimgs/summary.png"),
  test: require("./sidebarimgs/test.png"),
  uploadpres: require("./sidebarimgs/uploadpres.png"),
  security: require("./sidebarimgs/Security.png"),
  notification: require("./sidebarimgs/Notification.png"),
  globe: require("./sidebarimgs/Globe.png"),
  nutrition: require("./resultpgimgs/nutrition.png"),
  lifestyle: require("./resultpgimgs/lifestyle.png"),
  austria: require("./loginpgimgs/Austria.png"),
  belgium: require("./loginpgimgs/Belgium.png"),
  denmark: require("./loginpgimgs/Denmark.png"),
  finland: require("./loginpgimgs/Finland.png"),
  france: require("./loginpgimgs/France.webp"),
  germany: require("./loginpgimgs/Germany.png"),
  greece: require("./loginpgimgs/Greece.webp"),
  italy: require("./loginpgimgs/Italy.png"),
  netherlands: require("./loginpgimgs/Netherlands.png"),
  norway: require("./loginpgimgs/Norway.png"),
  poland: require("./loginpgimgs/Poland.png"),
  portugal: require("./loginpgimgs/Portugal.png"),
  spain: require("./loginpgimgs/Spain.png"),
  sweden: require("./loginpgimgs/Sweden.png"),
  switzerland: require("./loginpgimgs/Switzerland.webp"),
  selfie: require("./selfie.png"),
  userprofile: require("./resultnewimgs/userprofile.png"),
  assessmenticon: require("./resultnewimgs/assesmenticon.png"),
  // stagefive: require("./resultnewimgs/stage_5.png"),
  // stagefiveone: require("./resultnewimgs/stag_5.1.png"),
  hairanalysisicon: require("./resultnewimgs/hairanalysis.png"),
  crownarea: require("./resultnewimgs/crownarea.png"),
  scalp: require("./newimages/scalpReport.png"),
  hairstatus: require("./resultnewimgs/status.png"),
  scalp_conditioning: require("./resultnewimgs/conditioning.png"),
  scalp_treatment: require("./resultnewimgs/scalpproblem.png"),
  scalp_dandruff: require("./resultnewimgs/dandruff.png"),
  scalp_antifrizz: require("./resultnewimgs/antifrizz.png"),
  connect: require("./resultnewimgs/connect.png"),
  specialist: require("./resultnewimgs/specialist.png"),
  mail: require("./resultnewimgs/mail.png"),
  chat: require("../images/newimages/icons/chat.png"),
  phone: require("./resultnewimgs/phone_call.png"),

  // new images

  aloepexiaLanding: require("../images/newimages/onboardingImage.png"),
  alopexiaLogo: require("../images/newimages/alopexialogo.png"),
  mobileIcon: require("../images/newimages/ic-contact-mobile.svg"),
  hairlossaiLogo: require("../images/newimages/AloxaAI.png"),
  alopexiaLogoBlue: require("../images/newimages/alopexialogoblue.png"),
  checkmark: require("../images/newimages/check-mark.png"),

  // image upload images
  frontImg: require("../images/newimages/imgUpload/Front-side.png"),
  // 'backImg': require('../images/newimages/imgUpload/back.png'),
  leftImg: require("../images/newimages/imgUpload/Left-side.png"),
  rightImg: require("../images/newimages/imgUpload/Right-side.png"),
  topImg: require("../images/newimages/imgUpload/Top-side.png"),
  femaleFrontImg: require("../images/newimages/imgUpload/female-front-view.png"),
  femaleTopImg: require("../images/newimages/imgUpload/female-top-view.png"),
  // 'frontImg': require('../images/newimages/imgUpload/front.png'),
  // 'backImg': require('../images/newimages/imgUpload/back.png'),
  // 'leftImg': require('../images/newimages/imgUpload/left.png'),
  // 'rightImg': require('../images/newimages/imgUpload/right.png'),
  // 'topImg': require('../images/newimages/imgUpload/top.png'),
  frontImgPrev: require("../images/newimages/imgUpload/takephoto/front.png"),
  backImgPrev: require("../images/newimages/imgUpload/takephoto/back.png"),
  leftImgPrev: require("../images/newimages/imgUpload/takephoto/left.png"),
  rightImgPrev: require("../images/newimages/imgUpload/takephoto/right.png"),
  topImgPrev: require("../images/newimages/imgUpload/takephoto/top.png"),

  takeTopImg: require("../images/newimages/imgUpload/takephoto/top.png"),
  galleryTopImg: require("../images/newimages/imgUpload/takephoto/topGallery.png"),
  galleryPreviewImg: require("../images/newimages/imgUpload/takephoto/previewGallery.png"),

  leftArrow: require("../images/newimages/icons/backIcon.svg"),
  reportImg: require("../images/newimages/report.png"),

  topHairImg: require("../images/newimages/topHair.png"),

  healthyLifestyle: require("../images/newimages/assreport/healthy-lifestyle.png"),
  nutritionImg: require("../images/newimages/assreport/nutrition.png"),
  prescriptionImg: require("../images/newimages/prescriProfile.png"),

  mapProfile: require("../images/newimages/map.png"),
  mailIcon: require("../images/newimages/icons/mail.png"),

  signature: require("../images/newimages/prescsignature.png"),
  checkicon: require("./imgupload/check.png"),
  crossicon: require("./imgupload/cross.png"),
  previmg: require("./preview.png"),

  // product details
  product1: require("../images/newimages/productDetails/product.png"),
  masterCardIcon: require("../images/newimages/Icon_MasterCard.png"),

  // checkout icons
  gpayIcon: require("../images/newimages/checkoutpayment/gpay.png"),
  visaIcon: require("../images/newimages/checkoutpayment/visa.png"),
  paymentIcon: require("../images/newimages/checkoutpayment/papal.png"),
  masterIcon: require("../images/newimages/checkoutpayment/mc.png"),

  qrCodeBot: require("../images/newimages/whatsappQRCode.jpg"),

  landingAnimation: require("../images/newimages/landinganimation.gif"),
  // take photo gifs start

  frontPhotoGif: require("../images/newimages/imgUpload/gif/front-profile.gif"),
  leftPhotoGif: require("../images/newimages/imgUpload/gif/left-profile.gif"),
  rightImgPhotoGif: require("../images/newimages/imgUpload/gif/right-profile.gif"),
  topPhotoGif: require("../images/newimages/imgUpload/gif/down-profile.gif"),

  // take photo gifs end
  //result new images
  hairroots: require("../images/resultnewimgs/hair_roots.png"),
  scalpNew: require("../images/resultnewimgs/scalp.png"),
  stagetwoleft: require("../images/resultnewimgs/stage_2_left.png"),
  stagetwotop: require("../images/resultnewimgs/stage_2_top.png"),

  no_report_found: require("../images/no-report-ic.svg"),
  pdf_icon: require("../images/pdficon.png"),
  nocam_icon: require("../images/newimages/icons/nocam.png"),
  aloxa_header: require("../images/newimages/aloxaheader.png"),
  prescription_pad: require("../images/prescription.png"),

  //landing page icons

  cameraIcon:require("../images/icons/cameraIcon.png"),
  aiIcon:require("../images/icons/ai.png"),
  wpforms:require("../images/icons/wpforms.png"),
  stageImg:require("../images/newimages/actionStage.png"),

  // icons
  reportIcon:require("../images/newimages/icons/report-icon.png"),
  mobileTestIcon:require("../images/icons/smartphone.png"),
  ArrowGif:require("../images/icons/downArrowGif.gif"),
  prescriptionIcon:require("../images/newimages/icons/prescription-icon.png"),
  whatsAppIcon: require("../images/newimages/whatsappIcon.png"),
  defaultQr: require("../images/newimages/defaultQR.jpg"),
  helpIcon: require("../images/newimages/icons/help.png"),
  C1Qr: require("../images/newimages/C1Qr.png"),
  dummyReport: require("../images/newimages/dummyReport.png"),

  //new report ui images

  target:require("../images/newimages/reportNewImages/target.png"),
  enmale1:require("../images/newimages/reportNewImages/enmale1.png"),
  enmale2:require("../images/newimages/reportNewImages/enmale2.png"),
  enmale3:require("../images/newimages/reportNewImages/enmale3.png"),
  enmale4:require("../images/newimages/reportNewImages/enmale4.png"),
  enmale5:require("../images/newimages/reportNewImages/enmale5.png"),
  enmale6:require("../images/newimages/reportNewImages/enmale6.png"),
  enmale7:require("../images/newimages/reportNewImages/enmale7.png"),
  enfemale1:require("../images/newimages/reportNewImages/enfemale1.png"),
  enfemale2:require("../images/newimages/reportNewImages/enfemale2.png"),
  enfemale3:require("../images/newimages/reportNewImages/enfemale3.png"),
  enfemale4:require("../images/newimages/reportNewImages/enfemale4.png"),
  enfemale5:require("../images/newimages/reportNewImages/enfemale5.png"),
  esmale1:require("../images/newimages/reportNewImages/esmale1.png"),
  esmale2:require("../images/newimages/reportNewImages/esmale2.png"),
  esmale3:require("../images/newimages/reportNewImages/esmale3.png"),
  esmale4:require("../images/newimages/reportNewImages/esmale4.png"),
  esmale5:require("../images/newimages/reportNewImages/esmale5.png"),
  esmale6:require("../images/newimages/reportNewImages/esmale6.png"),
  esmale7:require("../images/newimages/reportNewImages/esmale7.png"),
  esfemale1:require("../images/newimages/reportNewImages/esfemale1.png"),
  esfemale2:require("../images/newimages/reportNewImages/esfemale2.png"),
  esfemale3:require("../images/newimages/reportNewImages/esfemale3.png"),
  esfemale4:require("../images/newimages/reportNewImages/esfemale4.png"),
  esfemale5:require("../images/newimages/reportNewImages/esfemale5.png"),
  frmale1:require("../images/newimages/reportNewImages/frmale1.png"),
  frmale2:require("../images/newimages/reportNewImages/frmale2.png"),
  frmale3:require("../images/newimages/reportNewImages/frmale3.png"),
  frmale4:require("../images/newimages/reportNewImages/frmale4.png"),
  frmale5:require("../images/newimages/reportNewImages/frmale5.png"),
  frmale6:require("../images/newimages/reportNewImages/frmale6.png"),
  frmale7:require("../images/newimages/reportNewImages/frmale7.png"),
  frfemale1:require("../images/newimages/reportNewImages/frfemale1.png"),
  frfemale2:require("../images/newimages/reportNewImages/frfemale2.png"),
  frfemale3:require("../images/newimages/reportNewImages/frfemale3.png"),
  frfemale4:require("../images/newimages/reportNewImages/frfemale4.png"),
  frfemale5:require("../images/newimages/reportNewImages/frfemale5.png"),

  // promo page images starts 
  bannerimg: require("../images/newimages/banner-white.png"),
  man: require("../images/newimages/campaignimages/man.png"),
  woman: require("../images/newimages/campaignimages/woman.png"),
  camera: require("../images/newimages/campaignimages/camera.png"),
  ai: require("../images/newimages/campaignimages/ai.png"),
  medicalReport: require("../images/newimages/campaignimages/medical-report.png"),
  //promopage images ends 
};

export default imgurl